import debounce from "lodash/debounce";

let $sections = null;
let $scrollNav = null;
let $header = null;

let isScrollWatcherDisabled = false;
let timer = null;

function deselect() {
    $scrollNav.find(".active").removeClass("active");
}

function select(id) {
    $scrollNav.find(`a[href="#${id}"]`).addClass("active");
}

function handleWindowScroll() {
    if (isScrollWatcherDisabled) return;

    const decisionline = $(window).scrollTop() + $(window).height() / 3;

    const $needle = $sections
        .filter(function () {
            return $(this).offset().top <= decisionline;
        })
        .last();

    deselect();

    if ($needle.length) {
        select($needle.attr("id"));
    }
}

function handleLinkClick(e) {
    e.preventDefault();

    clearTimeout(timer);
    isScrollWatcherDisabled = true;

    const target = $(this).attr("href");

    deselect();
    select(target.substring(1));

    window.scrollTo({
        top:
            $(target).offset().top -
            $header.outerHeight() -
            $scrollNav.outerHeight(),
        behavior: "smooth",
    });

    timer = setTimeout(() => {
        isScrollWatcherDisabled = false;
    }, 1000);
}

$(function () {
    $sections = $('section[data-rel="scroll-nav"]');
    $scrollNav = $(".js-scroll-nav");
    $header = $(".header");

    if ($scrollNav.length === 0) return;

    if ($sections.length !== 0) {
        $(window).on("scroll", debounce(handleWindowScroll, 200));
    }

    $(document).on("click", ".js-scroll-nav a", handleLinkClick);
});
